const PLACEHOLDER_AVATAR_FILES = new Set(['unknown.png', 'placeholder.svg']);

const AVATAR_COLORS = [
  '#1A73E8',
  '#E53935',
  '#8E24AA',
  '#00897B',
  '#F4511E',
  '#3949AB',
  '#D81B60',
  '#43A047'
];

const XML_ESCAPES = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&apos;'
};

const isPlaceholderAvatar = (url) => {
  const path = url.split('?')[0].split('#')[0];
  const file = path.split('/').pop()?.toLowerCase() || '';
  return PLACEHOLDER_AVATAR_FILES.has(file);
};

const normalizeAvatarUrl = (url) => {
  if (url.startsWith('http') || url.startsWith('/') || url.startsWith('data:')) return url;
  return `https://${url}`;
};

const avatarLabel = (user) => {
  const name = typeof user?.name === 'string' ? user.name.trim() : '';
  if (name) return name;
  const email = typeof user?.email === 'string' ? user.email.trim() : '';
  const local = email.split('@')[0]?.trim() || '';
  return local || 'U';
};

const hashLabel = (label) => {
  let hash = 0;
  for (let i = 0; i < label.length; i += 1) {
    hash = (hash * 31 + label.charCodeAt(i)) >>> 0;
  }
  return hash;
};

const avatarLetter = (label) => {
  const raw = Array.from(label)[0] || 'U';
  return /[a-z]/.test(raw) ? raw.toUpperCase() : raw;
};

export const initialAvatarDataUrl = (label) => {
  const source = String(label || '').trim() || 'U';
  const letter = avatarLetter(source).replace(/[&<>"']/g, (ch) => XML_ESCAPES[ch]);
  const color = AVATAR_COLORS[hashLabel(source) % AVATAR_COLORS.length];
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><circle cx="32" cy="32" r="32" fill="${color}"/><text x="32" y="32" dy=".35em" text-anchor="middle" fill="#fff" font-family="Arial,sans-serif" font-size="32" font-weight="500">${letter}</text></svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

export const resolveUserAvatarSrc = (user) => {
  const avatar = typeof user?.avatar === 'string' ? user.avatar.trim() : '';
  if (avatar && !isPlaceholderAvatar(avatar)) return normalizeAvatarUrl(avatar);
  return initialAvatarDataUrl(avatarLabel(user));
};
